// @flow
import Footer from "../../components/layout/Footer";
import {withTranslation} from "react-i18next";
import type {ApplicationState} from "../../reducers";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import RootNodeProvider from "../../helper/RootNodeProvider";
import Configuration from "../../Configuration";
import {RoleTypes} from "../../models/Role";

// Online revocation is offered only where a concrete dealer shop is the contract partner:
// DISTRIBUTOR (manufacturer page) and GARAGE_GROUP (group page before dealer selection, where
// dealerId is the group id) never show it; for the rest the dealer's shopEnabled decides. #56277
const ROLES_WITH_ONLINE_REVOCATION = [RoleTypes.DEALER, RoleTypes.GARAGE, RoleTypes.GROUP_DEALER];

export function computeCanShowOnlineRevocation(config: Object, cssBaseUrl: ?string): boolean {
    return !!config.dealerId && !!cssBaseUrl
        && !!config.isShopEnabled
        && ROLES_WITH_ONLINE_REVOCATION.includes(config.role);
}

function mapStateToProps(state: ApplicationState, ownProps) {
	const isLandingPage = !!RootNodeProvider.getPreviewRootNode() || !!RootNodeProvider.getRenderImprintRootNode();

	const privacyPolicy = isLandingPage ? state.config.privacyPolicy : null;
    const privacyPolicyLink = isLandingPage ? state.config.privacyPolicyLink : null;
	const imprintText = isLandingPage ? state.config.imprintText : null;
    const imprintLink = isLandingPage ? state.config.imprintLink : null;

    const cssBaseUrl = Configuration.value("cssBaseUrl");
    const canShowOnlineRevocation = computeCanShowOnlineRevocation(state.config, cssBaseUrl);
    const euShop = !!state.config.euShop;

    const showFooter = state.config.legalTerms || state.config.revocationTerms || state.config.revocationLink || imprintText || privacyPolicy || imprintLink || privacyPolicyLink || canShowOnlineRevocation || euShop;

	return {
		showFooter,
		legalTerms: state.config.legalTerms,
		revocationTerms: state.config.revocationTerms,
		revocationLink: state.config.revocationLink,
		paymentAgreement: false,
		dealerId: state.config.dealerId,
		cssBaseUrl,
		canShowOnlineRevocation,
		euShop,
		notificationUrl: Configuration.value("apiNotificationUrl"),
		privacyPolicy,
        privacyPolicyLink,
		imprintText,
        imprintLink,
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {};
}

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer)));
